import "./job.css";
import React, { useState } from 'react';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import MailOutline from '@material-ui/icons/MailOutline';
import FileCopyOutlined from '@material-ui/icons/FileCopyOutlined';
import ShoppingBasketOutlined from '@material-ui/icons/ShoppingBasketOutlined';
import SchoolOutlined from '@material-ui/icons/SchoolOutlined';
import img_benefitsme from '../../img/benfitsme_neu.png';


export default function Benefitsme()
 {  

    return    (
    <div id="wrapper">
        <div className="section_title">Benefits.me</div>
      <div style={{
         padding: "20px 20px",
         color: "#55ba5e",
         // fontWeight: "bold",
         backgroundColor:"#ffffff",
          width:"90%",
         padding:"10px",
         margin:"10px",
         float:"left"
       }}>



          <h2 className='angebote'> Attraktive und exklusive Angebote sowie viele Nachlässe</h2>
       <span style={{color:"#000000",fontSize:"14px"}}>
          
     <p> Über unsere Benefitplattform erhalten unsere Mitarbeiterinnen und Mitarbeiter exklusive Vergünstigungen von bis zu 86% bei regionalen und überregionalen Freizeitangeboten, Shows und Veranstaltungen, sowie in zahlreichen Onlineshops und Gastronomiebetrieben.
Bereitgestellt wird die Plattform von der Firma Benefits.me .
Benefits.me arbeitet mittlerweile mit über 3.000 Partnerunternehmen und 1.800 Anbietern zusammen. 
 
Zu den exklusiven Rabattaktionen zählen Event-Highlights wie Holiday on Ice oder Spiele der 1. und 2. Fußballbundesliga, Freizeit- und Ausflugsangebote wie Escape Rooms, Fotoshootings, diverse Freizeitparks, Urlaubsboxen oder Hotelgutscheine und exklusive Rabattaktionen in Onlineshops wie LG, TUI oder Puma.</p>

<img className='benefit' src={img_benefitsme}/>


<h1>Procuratio</h1>
<p> Nähere informationen im nachstehnden Info-Flyer.</p>
<p> Registrierungscode: procuratio-rabatte</p>
<a className='underline' href="https://procuratio.benefits.me" target="_blank">procuratio.benefits.me</a><br></br><br></br>


 
<a className='a-link-info' traget="_blank" href="https://intranet-backend.procuratio.com/nc/Intranet/Uploads/CB/Benefits_Flyer_procuratio.pdf"> ↔️  Infoflyer</a><br></br>

<h1>Procommendo</h1>
<p> Nähere informationen im nachstehnden Info-Flyer</p>
<p> Registrierungscode: procommendo-rabatte</p>
<a className='underline' traget="_blank" href="https://procommendo.benefits.me" target="_blank">procommendo.benefits.me</a><br></br><br></br>


 
<a className='a-link' traget="_blank" href="https://intranet-backend.procuratio.com/nc/Intranet/Uploads/CB/benefits_Flyer_proCommendo.pdf"> ↔️ Infoflyer</a><br></br>


</span>
       </div>
    </div>
    )

 }

